import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Chip, Button, Box } from '@material-ui/core';
import Auth from '@shared/services/Auth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[1],
  },
  chipsRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
  },
  actionsRow: {
    display: 'flex',
    gap: theme.spacing(1),
  },
}));

export const SubjectFilter = ({ filterSubjects, setFilterSubjects }) => {
  const classes = useStyles();
  const { subjects } = Auth.basics();

  const isSelected = (subjectName) => {
    if (!filterSubjects) return true;
    return filterSubjects.includes(subjectName);
  };

  const handleToggle = (subjectName) => {
    if (!filterSubjects) {
      // Currently showing all — select only this one
      setFilterSubjects([subjectName]);
      return;
    }

    if (filterSubjects.includes(subjectName)) {
      const next = filterSubjects.filter((s) => s !== subjectName);
      setFilterSubjects(next.length > 0 ? next : null);
    } else {
      setFilterSubjects([...filterSubjects, subjectName]);
    }
  };

  const handleSelectAll = () => {
    setFilterSubjects(null);
  };

  const handleDeselectAll = () => {
    setFilterSubjects([]);
  };

  return (
    <div className={classes.container}>
      <div className={classes.chipsRow}>
        {subjects.map((subject) => {
          const color = subject.color_teacher || subject.color;
          const selected = isSelected(subject.name);

          return (
            <Chip
              key={subject.name}
              label={subject.name}
              icon={
                subject.font_awesome_class ? (
                  <FontAwesomeIcon
                    icon={'fa-solid ' + subject.font_awesome_class}
                    style={{ color: selected ? 'white' : '#' + color, marginLeft: 8 }}
                  />
                ) : undefined
              }
              onClick={() => handleToggle(subject.name)}
              style={{
                backgroundColor: selected ? '#' + color : 'transparent',
                color: selected ? 'white' : '#' + color,
                border: selected ? 'none' : `1px solid #${color}`,
              }}
            />
          );
        })}
      </div>
      <Box className={classes.actionsRow}>
        <Button size="small" variant="outlined" onClick={handleSelectAll}>
          Tout sélectionner
        </Button>
        <Button size="small" variant="outlined" onClick={handleDeselectAll}>
          Tout désélectionner
        </Button>
      </Box>
    </div>
  );
};
